import i18next from "../../../i18n";

i18next.addResourceBundle("en", "Suppliers", {
    title: "Suppliers",
    subtitle:
        "Manage your suppliers. Multi select suppliers to perform bulk actions.",
    create_indicator_button: "Add Suppliers",
    search: "Search suppliers",
    export_suppliers_list: "Export suppliers list",
    export_last_questionnaire: "Export answers",
    export_last_questionnaire_tooltip:
        "Export the answers of the last questionnaire of each supplier",
});

i18next.addResourceBundle("fr", "Suppliers", {
    title: "Mes fournisseurs",
    subtitle:
        "Gérez vos fournisseurs. Sélectionnez plusieurs fournisseurs pour effectuer des actions groupées.",
    create_indicator_button: "Ajouter des fournisseurs",
    search: "Rechercher un fournisseur",
    export_suppliers_list: "Exporter la liste des fournisseurs",
    export_last_questionnaire: "Exporter les réponses",
    export_last_questionnaire_tooltip:
        "Exporter les réponses des derniers questionnaires de chaque fournisseur",
});
